import React, { Component, Fragment } from 'react';
import TuneIcon from '@material-ui/icons/Tune';
import {
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Input,
  Card,
  CardBody,
  CustomInput,
} from 'reactstrap';
import { connect } from 'react-redux';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import Select from 'react-select';
import ticketStatus from '../../../../../data/ticketStatus';
import ticketTags from '../../../../../data/tags';
import no_ticket_conversation from './../../../../../assets/no_ticket_conversation.png';
import messenger_icon from './../../../../../assets/messenger_icon.png';
import ticket_icon from './../../../../../assets/ticket_icon.png';
import google_icon from './../../../../../assets/google_icon.png';
import {
  gAPI_Tickets_By_Id,
  gAPI_Conversations_By_BotConversation,
  gAPI_TicketsRecording_id,
  gAPI_FormsTickets_By_Id,
  gAPI_Users_By_Id,
  gAPI_FormsCategoryList,
} from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import { getChat, getPropertyList } from '../../../../../redux/actions';
import ChatMessage from '../../../../../components/chats/ChatMessage';
import { injectIntl } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';
import 'moment-timezone';
import Validation from '../../../../../components/Validation';
import ArchivedTickets from '../../tickets/components/Archives';
import TicketVisitor from '../../../../../containers/pages/ticketVisitor';
const StatusOptions = [
  { value: 'open', label: 'Open' },
  { value: 'Pending', label: 'Assigned' },
  { value: 'solved', label: 'Solved' },
  { value: 'Escalated', label: 'Escalated' },
  // { value: 'spam', label: 'Spam' },
  // { value: 'archived', label: 'Archived' },
];

const StatusOptionMissed = [
  { value: 'AssignBusiness', label: 'Assign to Business' },
  { value: 'AssignBookmebob', label: 'Assign to Myma.ai' },
];

let headers = [
  { label: 'Title', key: 'title' },
  { label: 'Status', key: 'status' },
  { label: 'Date', key: 'date' },
  { label: 'Messages/Notes', key: 'messageNotes' },
];
class TicketsPage extends Component {
  constructor(props) {
    super(props);
    this._scrollBarRef1 = React.createRef();
    this.state = {
      startDate: moment().subtract(
        this.props.location !== undefined &&
          this.props.location.state !== undefined &&
          this.props.location.state.date != undefined
          ? this.props.location.state.date
          : 30,
        'days'
      ),
      endDate: moment(),
      hotel: {},
      embeddedDate: moment(),
      items: 20,
      tags: {},
      statuss: {},
      type:
        this.props.location !== undefined &&
        this.props.location.state !== undefined &&
        this.props.location.state.tagName != undefined
          ? this.props.location.state.tagName
          : undefined,
      offset: 0,
      loading: false,
      data: [],
      activeIndex: -1,
      selectedChat: null,
      isLoading: false,
      isLoadmore: true,
      showLoadMoreBtn: false,
      isFiltering: false,
      ticketData: {},
      conversationData: [],
      preTicketStatus: null,
      popupProperty: null,
      ticketModalData: {},
      recordingurl: '',
      transcript: '',
      isMissingURL: '',
      tagValue: '',
      statusValue: '',
      isMasked:
        sessionStorage.getItem('lock') === null
          ? 'false'
          : sessionStorage.getItem('lock'),
      selectedStatus: [],
      selectedTag: [],
      modelTicket: false,
      ticketType: null,
      ticketComments: '',
      missedResponseTitle: '',
      // data: this.props.getChatList({pid:'0b999af2-e798-49ae-bac6-b00559fde7d0',items:10,offset:0})
      csvReport: {
        data: [],
        headers: headers,
        filename: 'missing-response.csv',
      },
      userName: '',
      userEmail: '',
      assignee: '',
      open: false,
      msg: [],
      categoryList: [],
      ticketCategory: [],
      statusFilter: [],
      categoryFilter: [],
      isNewTicket: false,
      ticketTitle: '',
      ticketSelectedStatus: [],
      ticketAssignTo: '',
    };
  }

  componentDidMount() {
    this.props.getChat();
    var filterStatusList = [];
    StatusOptions.map((l) => filterStatusList.push({ ...l, checked: false }));
    this.setState({ statusFilter: filterStatusList });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      this.setState({ userName: res.data.fullName, userEmail: res.data.email });
    });
    const urll = window.location.pathname;
    const currentUrlName = urll.substring(urll.lastIndexOf('/') + 1);
    moment.tz.setDefault(this.props.timeZone);
    this.setState({ isLoading: true, isMissingURL: currentUrlName });
    var status = '-1';
    if (currentUrlName === 'missingresponse') {
      var selectedStatus = ticketStatus.filter((i) => i.value === 'Open');
      status = 'Open';
      this.setState({ selectedStatus: selectedStatus });
    }
    let { offset, items, startDate, endDate, type } = this.state;
    const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
    const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
    this.props.getPropertyList();
    var category = [];
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormsCategoryList}?groupId=${getGroupID()}&propertyId=${
        this.props.propertyId
      }&lang=${this.props.locale}`,
    }).then((res) => {
      res.data.map((l) => category.push({ ...l, checked: false }));
    });
    if (this.props?.tickets && this.props.tickets.length > 0) {
      var tag = [];
      this.props.tickets.map((i) => {
        if (i.tags.length > 0) {
          i.tags.map((k) => tag.push({ label: k, value: k }));
        }
      });
      this.setState((state) => ({
        data: [...state.data, ...this.props.tickets],
        items: 0,
        offset: 50,
        isLoading: false,
      }));

      var k = [...ticketTags, ...tag];
      var list = [...k, ...category];
      const unique = list.filter((obj, index) => {
        return index === list.findIndex((o) => obj.value === o.value);
      });
      var filtercate = [];
      unique.map((elem) => filtercate.push({ ...elem, checked: false }));
      this.setState({ categoryList: unique, categoryFilter: filtercate });

      let data = this.props.tickets;
      let ticketValue = [];
      var csvdata = { ...this.state.csvReport };
      if (data.length > 0) {
        data.map((elem) => {
          var status =
            StatusOptionMissed.filter((i) => i.value === elem.status).length > 0
              ? StatusOptionMissed.filter((i) => i.value === elem.status).map(
                  (i) => i.label
                )[0]
              : elem.status;
          ticketValue.push({
            title: elem.requesterName,
            status: status,
            date: moment(elem.creationTime).format('DD/MM/YYYY hh:mm a'),
            messageNotes: elem.notes,
          });
        });
        this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
        this.handleContactClick(
          0,
          data[0].id,
          data[0].conversationId,
          data[0].isTicket
        );
      }
      csvdata.data = ticketValue;
      this.setState({ csvReport: csvdata });
    }
  }

  //   componentWillReceiveProps(props) {
  //     if (
  //       props.chatListApp.selectedchat !== this.props.chatListApp.selectedchat
  //     ) {
  //       this.setState({ selectedChat: props.chatListApp.selectedchat });
  //     }
  //   }

  handleContactClick = (index, userId, conversationId, isticket) => {
    this.setState({ activeIndex: index });

    AxiosAPI({
      methhod: 'get',
      url: `${
        isticket === false ? gAPI_FormsTickets_By_Id : gAPI_Tickets_By_Id
      }/${userId}`,
    }).then((tres) => {
      if (conversationId !== '' && conversationId !== null) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Conversations_By_BotConversation}/${conversationId.replace(
            '|livechat',
            ''
          )}?gid=${getGroupID()}`,
        }).then((res) => {
          if (res.data.visitor && res.data.visitor.contactId) {
            AxiosAPI({
              methhod: 'get',
              url: `${gAPI_TicketsRecording_id}?contactid=${res.data.visitor.contactId}`,
            }).then(
              (urlres) => {
                this.setState({
                  recordingurl: urlres.data.url,
                  selectedChat: res.data,
                  ticketData: tres.data,
                  transcript: urlres.data.transcript,
                });
              },
              (error) => {
                console.log(error);
              }
            );
          } else {
            this.setState({
              recordingurl: '',
              selectedChat: res.data,
              ticketData: tres.data,
              transcript: '',
            });
          }
        });
      } else {
        this.setState({
          ticketData: tres.data,
          selectedChat: undefined,
        });
      }
    });
  };

  toggle = (item) => {
    if (item && item.id) {
      this.setState({ ticketModalData: item, selectedStatus: item.status });
    }
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };
  toggleNewTicket = () => {
    var selectedProperty =
      this.props.usersListApp.properties !== undefined
        ? this.props.usersListApp.properties
            .filter((elem) => elem.id === this.props.propertyId)
            .map((pro) => {
              return { label: pro.name, value: pro.id };
            })[0]
        : null;
    this.setState((prevState) => ({
      isNewTicket: !prevState.isNewTicket,
      ticketStatus: 'Pending',
      ticketSelectedStatus: [{ label: 'Assigned', value: 'Pending' }],
      popupProperty: selectedProperty,
    }));
  };

  localize(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }

  handleLoadMore = () => {};
  handleMaskClick = () => {
    if (sessionStorage.getItem('lock') === 'true') {
      sessionStorage.setItem('lock', 'false');
      this.setState({ isMasked: 'false' });
    } else {
      sessionStorage.setItem('lock', 'true');
      this.setState({ isMasked: 'true' });
    }
  };

  getImage = (phoneNumber, source) => {
    if (source === 'Phone') {
      if (phoneNumber !== '' && phoneNumber !== undefined) {
        if (
          phoneNumber.startsWith('+6422') ||
          phoneNumber.startsWith('+6427') ||
          phoneNumber.startsWith('+6421') ||
          phoneNumber.startsWith('+6428') ||
          phoneNumber.startsWith('+6429')
        ) {
          return 'https://assets.bookmebob.com/images/mobile.png';
        } else {
          return 'https://assets.bookmebob.com/images/landline.png';
        }
      } else {
        return 'https://assets.bookmebob.com/images/chat.png';
      }
    } else if (source === 'PhoneSuite') {
      return 'https://assets.bookmebob.com/images/664a7811-8899-4255-8fe8-a12a6bd8b500.png';
    } else if (source === 'WebsiteDirectLine') {
      return 'https://assets.bookmebob.com/images/2504d2db-ab38-4616-a7ea-d16a4e81bd6f.png';
    } else if (source === 'GoogleBusinessMessage') {
      return google_icon;
    } else if (source === 'WhatsApp') {
      return 'https://assets.bookmebob.com/images/whatsapp_icon.png';
    } else if (source === 'FacebookDirectLine') {
      return messenger_icon;
    } else {
      return ticket_icon;
    }
  };

  render() {
    const {
      usersListApp: { properties },
    } = this.props;

    const {
      selectedChat,
      ticketData,
      modal,
      preTicketStatus,
      ticketModalData,
      selectedStatus,
      selectedTag,
      modelTicket,
      ticketType,
      popupProperty,
      webRTCIntegration,
      rtcNumber,
      detailsTab,
      showDialPad,
      isNewTicket,
    } = this.state;
    const statusList =
      ticketModalData &&
      ticketModalData.status &&
      [...StatusOptions, ...StatusOptionMissed].filter(
        (i) => i.value === ticketModalData.status
      );

    const preFillStatus = ticketModalData &&
      ticketModalData.status && {
        value:
          statusList.length > 0
            ? statusList.map((i) => i.value)[0]
            : ticketModalData.status,
        label:
          statusList.length > 0
            ? statusList.map((i) => i.label)[0]
            : ticketModalData.status,
      };
    return (
      <Fragment>
        <div
        // style={{ marginLeft: '-3%', marginRight: '-3%', marginTop: '-0.75%' }}
        >
          <Row>
            <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4 pr-0">
              <Card>
                <div
                  className="card-body mt-0 ticketArchive"
                  style={{ padding: '15px 2px 0px 10px !important' }}
                >
                  <ArchivedTickets
                    getImage={this.getImage}
                    isAgentAssist={true}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    offset={this.state.offset}
                    items={this.state.items}
                    isLoading={this.state.isLoading}
                    data={this.state.data}
                    activeIndex={this.state.activeIndex}
                    handleContactClick={this.handleContactClick}
                    propertyId={this.props.propertyId}
                    isMissingUrl={
                      this.state.isMissingURL === 'missingresponse'
                        ? true
                        : false
                    }
                    tagValue={this.state.tagValue}
                    statusValue={this.state.statusValue}
                    handleLoadMore={this.handleLoadMore}
                    handleMaskClick={this.handleMaskClick}
                    isMasked={this.state.isMasked}
                    categoryList={this.state.categoryList}
                  />
                </div>
              </Card>
            </Colxx>
            <Colxx
              xxs="12"
              md="4"
              className="mb-2 col-sm-12 col-md-4 pl-1 pr-1"
            >
              {ticketData && ticketData.id && (
                <TicketVisitor
                  item={ticketData}
                  hideButton={true}
                  handleStatusClicked={(item) => this.toggle(item)}
                  conversation={selectedChat}
                  recordingurl={this.state.recordingurl}
                  transcript={this.state.transcript}
                  handleMaskClick={this.handleMaskClick}
                  isMasked={this.state.isMasked}
                  //toggleTicket={this.toggleTicket}
                  isMissingUrl={
                    this.state.isMissingURL === 'missingresponse' ? true : false
                  }
                />
              )}
            </Colxx>
            <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4 pl-0">
              {selectedChat !== undefined &&
              selectedChat !== null &&
              selectedChat !== '' ? (
                <Card
                  className="cardHeightTickets con-ticket-height"
                  style={{
                    overflow: 'scroll',
                    backgroundColor: selectedChat
                      ? `${selectedChat.colours.botBackground}`
                      : '#fff',
                    scrollbarColor: `darkgrey ${selectedChat.colours.botBackground}`,
                  }}
                >
                  <CardBody>
                    <div className="scroll  ">
                      {selectedChat && (
                        <div>
                          {selectedChat.messages != null &&
                            selectedChat.messages.length > 0 &&
                            selectedChat.messages.map((item, index) => {
                              // const sender = allContacts.find(x => x.id === item.sender);
                              return (
                                <ChatMessage
                                  key={index}
                                  sender={item.sender}
                                  item={item}
                                  avatar={selectedChat.avatar}
                                  colors={selectedChat.colours}
                                />
                              );
                            })}
                        </div>
                      )}
                    </div>
                  </CardBody>
                </Card>
              ) : (
                <Card className="cardHeightTickets text-center">
                  <img
                    src={no_ticket_conversation}
                    alt="No Active Conversations"
                    style={{
                      width: '60%',
                      marginTop: '8rem',
                      marginLeft: '6rem',
                    }}
                  />
                </Card>
              )}
            </Colxx>
          </Row>
          <Validation
            Open={this.state.Open}
            messages={this.state.msg}
            toggle={() => {
              this.setState({ Open: false });
            }}
          ></Validation>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ chatListApp, usersListApp, settings }) => {
  const { propertyId, timeZone, locale, email } = settings;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    email,
  };
};
export default injectIntl(
  connect(mapStateToProps, {
    getPropertyList,
    getChat,
  })(TicketsPage)
);
